import { IconButton, Progress, Stack } from 'rsuite';
import ReloadIcon from '@rsuite/icons/Reload';
interface IProps {
  instanceData: Record<string, any>;
  instanceDetail: Record<string, any>;
  refetch: any;
}

export const InstanceResource = ({
  instanceData,
  instanceDetail,
  refetch
}: IProps) => {
  const getColor = (percents: number) => {
    if (percents >= 90) {
      return '#d43527';
    } else if (percents >= 80) {
      return '#e28722';
    } else if (percents >= 70) {
      return '#f3bb2d';
    } else {
      return undefined;
    }
  };
  return (
    <>
      {/* <div className="grid-item quota-resource small">
          <div className="grid-header">
            <div className="title">
              <i className="icon-fontello-monitor-graph"></i>
              Quota Usage
            </div>
          </div>
          <div className="grid-content">
            <div
              style={{ width: '100%', display: 'grid', placeItems: 'center' }}
            >
              <div style={{ height: '150px', width: '125px' }}>
                <Progress.Circle percent={157} strokeColor={getColor(157)} />
              </div>
              <Stack spacing={10} style={{ fontSize: '0.95em' }}>
                <div>
                  <span>{'Entitled'}:</span>
                  <b style={{ fontSize: '1.2em', padding: '0 4px' }}>15</b>
                  <span>{`GB/Day`}</span>{' '}
                </div>
                <div>
                  <span>{'Used'}:</span>
                  <b style={{ fontSize: '1.2em', padding: '0 4px' }}>24</b>
                  <span>{`GB/Day`}</span>
                </div>
              </Stack>
              <div>
                <span style={{ color: 'green' }}>Recommended Storage: </span>
                <b style={{ fontSize: '1.2em', padding: '0 4px' }}>25</b>
                <span>{`GB/Day`}</span>{' '}
              </div>
            </div>
          </div>
        </div> */}

      <div className="grid-item disk-resource small">
        <div className="grid-header">
          <div className="title">
            <i className="icon-fortinetone-fortiAnalyzerIcon"></i>
            Disk Usage
          </div>
          {/* <IconButton
            title="Reload"
            icon={<ReloadIcon />}
            appearance="default"
            circle
            className="icon-btn"
            onClick={refetch}
          /> */}
        </div>
        <div className="grid-content">
          <div style={{ width: '100%', display: 'grid', placeItems: 'center' }}>
            <div style={{ height: '150px', width: '125px' }}>
              <Progress.Circle
                percent={Number(instanceDetail?.disk?.percent || 0)}
                strokeColor={getColor(
                  Number(instanceDetail?.disk?.percent || 0)
                )}
              />
            </div>
            <Stack spacing={10} style={{ fontSize: '0.95em' }}>
              <div>
                <span>{'Disk'}:</span>
                <b style={{ fontSize: '1.2em', padding: '0 4px' }}>
                  {(Number(instanceDetail?.disk?.size || 0) / 1000).toFixed(2)}
                </b>
                <span>{`GB`}</span>{' '}
              </div>
              <div>
                <span>{'Used'}:</span>
                <b style={{ fontSize: '1.2em', padding: '0 4px' }}>
                  {(Number(instanceDetail?.disk?.used || 0) / 1000).toFixed(2)}
                </b>
                <span>{`GB`}</span>
              </div>
            </Stack>
          </div>
        </div>
      </div>

      <div className="grid-item disk-resource small">
        <div className="grid-header">
          <div className="title">
            <i className="icon-fontello-monitor-graph"></i>
            Resource Usage
          </div>
          {/* <IconButton
            title="Reload"
            icon={<ReloadIcon />}
            appearance="default"
            circle
            className="icon-btn"
            onClick={refetch}
          /> */}
        </div>
        <div className="grid-content">
          <div>
            <Stack spacing={10}>
              <Stack.Item>vCPU</Stack.Item>
              <Stack.Item>{`( ${instanceData?.vcpus} )`}</Stack.Item>
              <Stack.Item flex={1}>
                <Progress.Line
                  percent={Number(instanceData?.cpu_usage || 0)}
                  strokeColor={getColor(Number(instanceData?.cpu_usage || 0))}
                />
              </Stack.Item>
            </Stack>
            <Stack spacing={10}>
              <Stack.Item>RAM</Stack.Item>
              <Stack.Item>{`( ${instanceData?.ram} GB)`}</Stack.Item>
              <Stack.Item flex={1}>
                <Progress.Line
                  percent={Number(instanceData?.mem_usage || 0)}
                  strokeColor={getColor(Number(instanceData?.mem_usage || 0))}
                />
              </Stack.Item>
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};
